import stats from '../../json/captainStats.json';

/**
 * @author James Adams
 */
function CaptainState(id){
  this.createPageState(id,{
    name:"",
    title:"Captain",
    background:"Biomorph",
    statChoices:{},
    level: stats.level,

    move: stats.move,
    fight: stats.fight,
    shoot: stats.shoot,
    armor: stats.armor,
    will: stats.will,
    health: stats.health + 1, //default biomorph stat mod
    gearSlots: stats.gearSlots,
    gear:[],

    addRoster:null,
    errorMessage:""
  }
  );
}

export default CaptainState;
